exports = module.exports = require("../../../../../../../../../../../../home/krylancelo/tmp/node_modules/Artetia/beta/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/krylancelo/OS/Data/Work/krylab/Artetia/beta/src/app/shared/fixedplugin/fixedplugin.component.css
// module id = ../../../../../../../../../../../media/krylancelo/OS/Data/Work/krylab/Artetia/beta/src/app/shared/fixedplugin/fixedplugin.component.css
// module chunks = main